var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBattery = function SvgBattery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 15,
    fill: "#FCA14C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#battery_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5 20H32v-2.25a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75V20h-1.5c-.826 0-1.5.674-1.5 1.5v18c0 .842.659 1.5 1.5 1.5h9c.842 0 1.5-.658 1.5-1.5v-18c0-.841-.658-1.5-1.5-1.5ZM29 36.5V32h-3l3-7.5V29h3l-3 7.5Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "battery_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(18.5 17)",
    d: "M0 0h21v24H0z"
  })))));
};
export default SvgBattery;